import {
  configApiRef,
  createFrontendModule,
} from '@backstage/frontend-plugin-api';
import { AnalyticsImplementationBlueprint } from '@backstage/plugin-app-react';
import { AmplitudeAnalytics } from './analytics';

const amplitudeAnalyticsExtension = AnalyticsImplementationBlueprint.make({
  params: defineParams =>
    defineParams({
      deps: { configApi: configApiRef },
      factory: ({ configApi }) => AmplitudeAnalytics.fromConfig(configApi),
    }),
});

export const amplitudeAnalyticsModule = createFrontendModule({
  pluginId: 'app',
  extensions: [amplitudeAnalyticsExtension],
});
